/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Servicio from "./Componentes/Detalle_Servicio";
import Detalle_Sobre_Servicio from "./Componentes/Detalle_Sobre_Servicio";
import Detalle_Registro_Preguntas from "./Componentes/Detalle_Registro_Preguntas";
import Home_Profesionales from "./Componentes/Home_Profesionales";
import Home_Testimonios from "./Componentes/Home_Testimonios";

const Seccion_Detalle = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Detalle_Servicio/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Detalle_Sobre_Servicio/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Detalle_Registro_Preguntas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 12}}>
                <Home_Profesionales/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 12}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle